import React from "react";
import { Box, Typography, Grid, Button, Container } from "@mui/material";
import { Link } from "react-router-dom";

export default function AngelInvestorPage() {
    return (
        <Box sx={{ backgroundColor: "#f8f8f8", minHeight: "100vh", py: 6 }}>
            <Container maxWidth="lg">
                {/* Başlık ve Giriş */}
                <Box sx={{ textAlign: "left", mb: 6 }}>
                    <Typography variant="h3" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                        Ardventure'nin Melekleri
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: "#555",
                            mb: 4,
                            lineHeight: 1.8,
                        }}
                    >
                        Melek Yatırımın Dijital Formu: Ardventure'ın Melekleri Nedir?
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#777", lineHeight: 1.8 }}>
                        Melek yatırım, girişimcilere destek olma ve başarılı projelerin yeni nesline yatırım yapma fırsatı sunar. Ardventure'ın Melekleri, bu geleneksel yatırım yaklaşımını dijital çağa taşıyan, yatırımcıları ve girişimcileri bir araya getiren bir platformdur.
                    </Typography>
                </Box>

                {/* Avantajlar */}
                <Grid container spacing={4}>
                    {/* Yatırımcı Keşfi */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                boxShadow: 3,
                                p: 4,
                                borderRadius: 2,
                                height: "100%",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                1. Yatırımcı Keşfi
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>
                                Ardventure'nin Melekleri, yatırımcıları bir araya getirerek potansiyel yatırım fırsatlarını keşfetmelerine olanak tanır. Kullanıcılar, farklı sektörlerdeki projeler arasında gezinebilir, ilgi alanlarına göre filtre uygulayabilir ve ilgisini çeken projeleri inceleyebilirler.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Kolay ve Şeffaf Yatırım */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                boxShadow: 3,
                                p: 4,
                                borderRadius: 2,
                                height: "100%",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                2. Kolay ve Şeffaf Yatırım
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>
                                Yatırımcılar, platformdaki projeleri detaylı bir şekilde inceleyebilirler. Finansal bilgilere, değerlemelere ve diğer yatırımcılardan gelen geri bildirimlere erişebilirler.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Portföy Yönetimi */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                boxShadow: 3,
                                p: 4,
                                borderRadius: 2,
                                height: "100%",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                3. Portföy Yönetimi
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>
                                Yatırımcılar, portföylerini platformun uygulaması veya web sitesi üzerinden kolayca takip edebilirler. Portföylerini çeşitlendirebilir ve projelerin durumu hakkında anlık güncellemeler alabilirler.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Girişimciler İçin */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                boxShadow: 3,
                                p: 4,
                                borderRadius: 2,
                                height: "100%",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                4. Girişimciler İçin
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>
                                Ardventure'nin Melekleri, girişimcilerin projelerini sergilemeleri ve yatırım taleplerini paylaşmaları için bir platform sunar. Yatırımcılara ulaşmak ve projelerini sunmak için ideal bir alan sağlar.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Görsel ve Bilgilendirme */}
                <Box
                    sx={{
                        mt: 8,
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4, color: "#1769aa" }}>
                        Melek Yatırım: Nedir ve Nasıl Melek Yatırımcı Olunur?
                    </Typography>
                    <Grid container spacing={4} alignItems="left">
                        {/* Görsel */}
                        <Grid item xs={12} md={6}>
                            <img
                                src="/img/angel-invest.jpeg" // Görsel yolu
                                alt="Melek Yatırımcı"
                                style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                }}
                            />
                        </Grid>

                        {/* Bilgi */}
                        <Grid item xs={12} md={6} alignItems="left" sx={{ textAlign: "left" }}>
                            <Typography variant="body1" sx={{ textAlign: "left", color: "#555", lineHeight: 1.8 }}>
                                Bir melek yatırımcı, genellikle şirketin mülkiyetindeki hisse senedi karşılığında erken aşama girişimcilere finansal destek sağlayan yüksek net değerli bir bireydir. Melek yatırımcılar tarafından sağlanan fonlar, start-up'ların tohum aşamasından büyüme aşamasına geçiş yapmalarına yardımcı olur.
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{ textAlign: "left", color: "#555", mt: 2, lineHeight: 1.8 }}
                            >
                                Ülkemizde melek yatırımcı olabilmek için yüksek gelire veya varlığa sahip bireyler bu fırsattan yararlanabilir. Ayrıca, yatırım deneyimi olan profesyoneller de melek yatırımcı olabilir.
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{
                                    mt: 4,
                                    backgroundColor: "#1769aa",
                                    color: "#fff",
                                    textTransform: "none",
                                    "&:hover": {
                                        backgroundColor: "#145a8c",
                                    },
                                }}
                                component={Link}
                                to="/kayit-ol"
                            >
                                Melek Yatırımcı Ol
                            </Button>

                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
}